import React from 'react';
import { Button } from '@design-system/button';
import { TriangleAlert, X } from 'lucide-react';
import { useReminderBarHidden } from './use-reminder-bar-hidden';

type ReminderBarProps = {
  className?: string;
  progressText?: string;
  message: string;
  buttonText: string;
  onButtonClick?: () => void;
  hidable?: boolean;
  hiddenOnPages?: string[];
};

export const ReminderBar: React.FC<ReminderBarProps> = ({
  className,
  progressText,
  message,
  buttonText,
  onButtonClick,
  hidable = false,
  hiddenOnPages = [],
}) => {
  const { hidden, handleDismiss } = useReminderBarHidden(
    buttonText,
    hidable,
    hiddenOnPages
  );

  if (hidden) return null;

  return (
    <div
      className={`relative flex items-center flex-wrap sm:flex-nowrap justify-between border-b border-dashed border-blue-300 bg-white px-6 py-3 shadow-sm ${className ?? ''}`}
    >
      <div className='flex items-center'>
        <div className='bg-primary-100  disabled:border-primary-50 disabled:bg-primary-50 disabled:text-primary-400 p-2 rounded-[10px] mr-[8px]'>
          <TriangleAlert
            className='text-primary-1000'
            size={20}
          />
        </div>
        <div>
          {progressText && (
            <p className='font-medium text-primary-900 text-sm sm:text-base'>
              {progressText}
            </p>
          )}
          <p className='text-gray-600 text-xs sm:text-sm'>{message}</p>
        </div>
      </div>

      <div className='flex gap-2'>
        {onButtonClick && (
          <Button
            variant={'secondary'}
            size='sm'
            onClick={onButtonClick}
            className='sm:ml-[0] ml-[auto]'
          >
            {buttonText}
          </Button>
        )}

        {hidable && (
          <Button
            variant='ghost'
            size='iconXs'
            className='hover:opacity-100 opacity-50'
            onClick={handleDismiss}
          >
            <X />
          </Button>
        )}
      </div>
    </div>
  );
};
